'use strict';

var TabbedContentView = require('./components/TabbedContentView'),
  AjaxTabbedContentView = require('./components/AjaxTabbedContentView'),
  $ = require('jquery');

// Create tabbed content view
$('.TabbedContent').each(function() {
  new AjaxTabbedContentView({
    el: this
  });
});

// Create tabbed content view (without Ajax calls)
$('.js-TabbedContent--onPage').each(function() {
  new TabbedContentView({
    el: this
  });
});



// WEBPACK FOOTER //
// ./assets/js/tabbed-content.js